<template>
  <div class="navbar">
    <aside :class="{'hidden': isSidebarHidden}">
      <div class="navcontent flexcolumn">
        <div class="navhead flexcolumn-item flexcolumn">
          <router-link
            class="home-link flexcolumn-item"
            to="/"
            @click="toggleSidebar()"
          >
            <div
              class="company-logo has-text-centered"
            >
              <!-- <img
                src="../../assets/kitsu.png"
                v-if="!isDarkTheme"
              /> -->
              <img
                src="../../assets/kitsu-dark.png"
              />
              <span class="logo-text">
                INTRANET
              </span>
            </div>
          </router-link>

          <div
            class="flexcolumn-item"
            v-if="isProductionContext"
          >
            <h2>{{ $t('main.production') + ':'}}</h2>
            <combobox
              class="context-selector production-select"
              :options="openProductionOptions"
              :is-top="true"
              v-model="currentProductionId"
            />
            <div
              v-if="isTVShow"
              class="ep-list-container"
            >
              <h3 v-if="isEpisodeContext">{{ $t('episodes.title') + ':'}}</h3>
              <topbar-episode-list
                class="context-selector"
                v-if="isEpisodeContext"
                :episode-groups="currentEpisodeOptionGroups || []"
                :episode-id="currentEpisodeId"
                :section="currentProjectSection"
              />
            </div>
          </div>

          <div
            class="flexcolumn-item" 
            v-else-if="lastProduction"
          >
            <p>
              <router-link
                :to="lastSectionPath"
              >
                >&nbsp;Back&nbsp;to&nbsp;production: {{ lastProduction.name }}
              </router-link>
            </p>
          </div>
        </div>

        <section class="flexcolumn-item">
          <div v-if="isProductionContext">
            <template v-if="!isCurrentUserClient">
              <tree-indent
                @title-click="pushContextRoute('schedule')"
                icon-name="schedule"
                :title="$t('schedule.title')"
                :loading="isSortedScheduleLoading"
                :branch="false"
                :bold="true"
                :bright="true"
                :quiet="true"
              >
                <div
                  :key="L0elem.id"
                  v-for="(L0elem, si0) in effSchedule"
                  :ref="si0 === currentSortedSchedule.length - 1 ? 'sched0' : ''"
                >
                  <tree-indent
                    @icon-click="toggleElem(L0elem)"
                    @title-click="buildFilterUrl([ L0elem ])"
                    :title="L0elem.name"
                    :force-expand="L0elem.expanded && L0elem.children.length > 0"
                    :bright="isSchedLit(L0elem)"
                    :bold="isSchedLit(L0elem)"
                    :quiet="true"
                  >
                    <div
                      :key="L1elem.id"
                      v-for="(L1elem, si1) in L0elem.children"
                      :ref="si0 === currentSortedSchedule.length - 1 ? 'sched1' + L0elem.id : ''"
                    >
                      <tree-indent
                        @icon-click="toggleElem(L1elem)"
                        @title-click="buildFilterUrl([ L0elem, L1elem ])"
                        :title="L1elem.name"
                        :force-expand="L1elem.expanded && L1elem.children.length > 0"
                        :bright="isSchedLit(L1elem)"
                        :bold="isSchedLit(L1elem)"
                        :quiet="true"
                      >
                        <div 
                          v-if="si0 === 0 && scheduleSortMode === 1 && currentSortedSchedule[4].children.length > si1"
                          class="seq-task-area-side"
                        >
                          <tree-indent
                            :key="L2elem.id"
                            v-for="L2elem in currentSortedSchedule[4].children[si1].children"
                            @title-click="buildFilterUrl([ L0elem, L1elem, L2elem ])"
                            :title="L2elem.name"
                            :bright="isSchedLit(L2elem)"
                            :bold="isSchedLit(L2elem)"
                          />
                        </div>

                        <tree-indent
                          :key="L2elem.id"
                          v-for="L2elem in L1elem.children"
                          @title-click="buildFilterUrl([ L0elem, L1elem, L2elem ])"
                          :title="L2elem.name"
                          :bright="isSchedLit(L2elem)"
                          :bold="isSchedLit(L2elem)"
                        />
                      </tree-indent>
                    </div>
                  </tree-indent>
                </div>
              </tree-indent>

              <tree-indent
                @title-click="pushContextRoute('breakdown')"
                icon-name="breakdown"
                :title="$t('breakdown.title')"
                :branch="false"
                :loading="false"
                :bold="true"
                :bright="false"
              />
              <tree-indent
                v-if="isCurrentUserAdmin"
                @title-click="pushContextRoute('quota')"
                icon-name="quota"
                :title="$t('quota.title')"
                :branch="false"
                :loading="false"
                :bold="true"
                :bright="false"
              />

              <tree-indent
                @title-click="pushContextRoute('team')"
                icon-name="team"
                :title="$t('people.team')"
                :branch="false"
                :bold="true"
                :bright="true"
              >
                <tree-indent
                  :key="person.id"
                  v-for="person in currentTeam"
                  @title-click="pushContextRoute('person', {
                    params: { person_id: person.id },
                    query: { search: currentProduction.name }
                  })"
                  :title="person.name"
                />
                <div class="peoplespacer"></div>
                <tree-indent
                  :key="person.id"
                  v-for="person in currentTeam"
                  @title-click="pushContextRoute('person', {
                    params: { person_id: person.id },
                    query: currentProduction.name
                  })"
                  :title="person.name"
                />
                <!-- <p
                  :key="person.id"
                  v-for="person in currentClients"
                >
                  <router-link
                    :to="{
                      name: 'person',
                      params: { person_id: person.id },
                      query: { search: currentProduction.name },
                    }"
                    :title="person.full_name"
                    class="name-link"
                  >
                    ┄○ {{ person.name }}
                  </router-link>
                </p> -->
              </tree-indent>
            </template>

            <tree-indent
              icon-name="quota"
              :title="$t('statistics.title')"
              :branch="false"
              :bold="true"
            >
              <tree-indent
                v-if="isTVShow"
                @title-click="pushContextRoute('episode-stats')"
                :title="$t('episodes.stats_title')"
              />
              <tree-indent
                @title-click="pushContextRoute('sequence-stats')"
                :title="$t('sequences.stats_title')"
              />
              <tree-indent
                @title-click="pushContextRoute('production-asset-types')"
                :title="$t('asset_types.production_title')"
              />
            </tree-indent>

            <tree-indent
              v-if="isTVShow"
              @title-click="pushContextRoute('episodes')"
              icon-name="episodes"
              :title="$t('episodes.title')"
              :branch="false"
              :loading="loadingEpseq"
              :bold="true"
              :bright="true"
            >
              <tree-indent
                v-for="(ep, epid) in epSeqTree"
                :key="'nav-ep-' + epid"
                @title-click="$router.push(getEpisodePath(epid))"
                :title="ep.name"
                :branch="true"
                :bold="isEpLit(epid)"
                :bright="isEpLit(epid)"
                :quiet="true"
              >
                <tree-indent
                  v-for="(seq, seqid) in ep.cont"
                  :key="'nav-ep-' + epid + seqid"
                  @title-click="onSequenceClick(seqid, epid)"
                  :title="seq.name"
                  :branch="true"
                  :bold="isSeqLit(seq)"
                  :bright="isSeqLit(seq)"
                  :quiet="true"
                >
                  <tree-indent
                    :key="'nav-ep-' + epid + seqid + shid"
                    v-for="(sh, shid) in seq.cont"
                    @title-click="pushContextRoute('shot', getShotPath(shid))"
                    :bright="isShotLit(shid)"
                    :title="sh"
                  />
                </tree-indent>
              </tree-indent>
            </tree-indent>

            <tree-indent
              @title-click="pushContextRoute('sequences')"
              icon-name="sequences"
              :title="'Tasks - ' + $t('sequences.title')"
              :loading="loadingEpseq"
              :branch="false"
              :expandable="!isTVShow"
              :bold="true"
              :bright="!isTVShow"
            >
              <tree-indent
                v-for="(seq, seqid) in epSeqTree"
                :key="'nav-seq-' + seqid"
                @title-click="onSequenceClick(seqid)"
                :title="seq.name"
                :branch="true"
                :bold="isSeqLit(seq)"
                :bright="isSeqLit(seq)"
                :quiet="true"
              >
                <tree-indent
                  :key="'nav-seq-' + seqid + shid"
                  v-for="(sh, shid) in seq.cont"
                  @title-click="pushContextRoute('shot', getShotPath(shid))"
                  :bright="isShotLit(shid)"
                  :title="sh"
                />
              </tree-indent>
            </tree-indent>

            <template v-if="!isCurrentUserClient">
              <tree-indent
                v-for="cat in ['shots', 'assets', 'edits']"
                :key="'side_nav_' + cat"
                @title-click="pushContextRoute(cat)"
                :icon-name="cat"
                :title="'Tasks - ' + $t(cat + '.title')"
                :loading="isTasksLoading(cat)"
                :branch="false"
                :bold="true"
                :bright="true"
              >
                <tree-indent
                  :key="'side_tsk_' + departmentId"
                  v-for="(columns, departmentId) in taskList(cat)"
                  @title-click="pushContextRoute(cat, {
                    search: '',
                    dep: departmentId
                  })"
                  :title="departmentMap.get(departmentId).name"
                  :branch="true"
                >
                  <tree-indent
                    :key="columnId"
                    v-for="columnId in columns"
                    @title-click="taskTypePath(columnId, cat)"
                    :title="taskTypeMap.get(columnId).name"
                  />
                </tree-indent>
              </tree-indent>

              <tree-indent
                @title-click="pushContextRoute('management')"
                icon-name='task-types'
                :title="'Tasks - ' + $t('management.title')"
                :branch="false"
                :bold="true"
                :bright="true"
              >
                <tree-indent
                  :key="'side_tsk_' + departmentId"
                  v-for="(columns, departmentId) in managementTasks"
                  @title-click="$router.push({
                    name: 'management',
                    query: {
                      search: '',
                      dep: departmentId
                    }
                  })"
                  :title="departmentMap.get(departmentId).name"
                  :branch="true"
                >

                  <tree-indent
                    :key="columnId"
                    v-for="columnId in columns"
                    :title="taskTypeMap.get(columnId).name"
                  />
                </tree-indent>
              </tree-indent>
            </template>


            <tree-indent
              @title-click="pushContextRoute('playlists')"
              icon-name="playlists"
              :title="$t('playlists.title')"
              :branch="false"
              :loading="false"
              :bold="true"
              :bright="false"
            />
            <tree-indent
              v-if="!isCurrentUserClient"
              @title-click="pushContextRoute('news-feed')"
              icon-name="newsFeed"
              :title="$t('news.title')"
              :branch="false"
              :loading="false"
              :bold="true"
              :bright="false"
            />
            <tree-indent
              v-if="isCurrentUserAdmin"
              @title-click="pushContextRoute('production-settings')"
              icon-name="settings"
              :title="$t('settings.title')"
              :branch="false"
              :loading="false"
              :bold="true"
              :bright="false"
            />
          </div>

          <div v-else-if="isCurrentUserAdmin">
            <h2>{{ $t('main.admin')}}</h2>
            <p @click="toggleSidebar()">
              <router-link :to="{name: 'departments'}">
                {{ $t("departments.title") }}
              </router-link>
            </p>
            <p @click="toggleSidebar()">
              <router-link to="/task-types">
              {{ $t("task_types.title") }}
              </router-link>
            </p>
            <p @click="toggleSidebar()">
              <router-link to="/task-status" class="task-status-link">
              {{ $t("task_status.title") }}
              </router-link>
            </p>
            <p @click="toggleSidebar()">
              <router-link to="/asset-types">
              {{ $t("asset_types.title") }}
              </router-link>
            </p>
            <p @click="toggleSidebar()">
              <router-link :to="{name: 'custom-actions'}">
              {{ $t("custom_actions.title") }}
              </router-link>
            </p>
            <p @click="toggleSidebar()">
              <router-link :to="{name: 'status-automations'}">
                {{ $t("status_automations.title") }}
              </router-link>
            </p>
            <p @click="toggleSidebar()">
              <router-link :to="{name: 'settings'}">
                {{ $t("settings.title") }}
              </router-link>
            </p>
            <p @click="toggleSidebar()">
              <router-link :to="{name: 'logs'}">
                {{ $t("logs.title") }}
              </router-link>
            </p>
          </div>

        </section>
      </div>
    </aside>
  </div>
</template>

<script>
import {
  MinusSquareIcon,
  PlusSquareIcon
} from 'vue-feather-icons'

import { mapGetters, mapActions } from 'vuex'
import { sortColumnsByDepartment } from '@/lib/sorting'
import func from '@/lib/func'

import { productionScheduleMixin } from '@/components/mixins/productionSchedule'
import Combobox from '@/components/widgets/Combobox'
import TreeIndent from '@/components/widgets/TreeIndent'
import TopbarEpisodeList from '@/components/tops/TopbarEpisodeList'

import KitsuIcon from '@/components/widgets/KitsuIcon'

export default {
  name: 'sidebar',
  mixins: [productionScheduleMixin],
  components: {
    Combobox,
    MinusSquareIcon,
    PlusSquareIcon,
    TopbarEpisodeList,
    KitsuIcon,
    TreeIndent
  },

  data() {
    return {
      currentProductionId: this.$route.params.production_id,
      currentEpisodeId: this.$route.params.episode_id,
      currentProjectSection: this.isCurrentUserClient ? 'playlists' : 'shots',
      title: '',
      logoPath: '',
      managementTasks: [],
      episodeSelection: null,
      epSeqTree: {},
      loadingEpseq: false,
      expanded: [],
    }
  },

  mounted () {
    const productionId = localStorage.getItem('last-production')
    this.updateContext(productionId)
    this.reset()
  },

  computed: {
    ...mapGetters([
      'currentSortedSchedule',
      'departments',
      'departmentMap',
      'episodeOptionGroups',
      'episodeMetadataDescriptors',
      'episodeMap',
      'sequenceMap',
      'scheduleSortMode',
      'isSortedScheduleLoading',
      'isSidebarHidden',
      'isDarkTheme',
      'isCurrentUserAdmin',
      'isCurrentUserCGArtist',
      'isCurrentUserClient',
      'isCurrentUserManager',
      'isCurrentUserSupervisor',
      'isCurrentUserVendor',
      'isShotsLoading',
      'isAssetsLoading',
      'isEditsLoading',
      'isEpisodesLoading',
      'organisation',
      'assetsPath',
      'currentEpisode',
      'currentProduction',
      'episodes',
      'episodeOptions',
      'sequences',
      'displayedSequences',
      'displayedEpisodes',
      'displayedShotsBySequence',
      'lastProductionScreen',
      'lastProductionViewed',
      'openProductions',
      'openProductionOptions',
      'productionMap',
      'personMap',
      'getTaskType',
      'taskTypes',
      'taskTypeMap',
      'taskMap',
      'shotMap',
      'isTVShow',
      'people',
      'productionManagementTaskTypes',
      'shotValidationColumns',
      'assetValidationColumns',
      'editValidationColumns'
    ]),

    currentPeople() {
      return this.currentProduction.team.map(id => this.personMap.get(id))
    },

    currentTeam() {
      return this.currentPeople.filter(p => p.role !== 'client')
    },
    
    currentClients() {
      return this.currentPeople.filter(p => p.role === 'client')
    },

    shotTasks () {
      return this.formatTaskTypeList(this.shotValidationColumns)
    },

    assetTasks () {
      return this.formatTaskTypeList(this.assetValidationColumns)
    },

    editTasks () {
      return this.formatTaskTypeList(this.editValidationColumns)
    },

    assetTaskTypes () {
      return this.taskTypes.filter((t) => {
        return !t.for_shots
      })
    },

    shotTaskTypes () {
      return this.taskTypes.filter((t) => {
        return t.for_shots
      })
    },

    assetSections () {
      return ['assets', 'assetTypes', 'playlists']
    },

    effSchedule () {
      if (this.scheduleSortMode === 1) {
        return this.currentSortedSchedule.slice(0, -1)
      }
      return this.currentSortedSchedule
    },


    // Asset pages require a all section and a main pack section.
    currentEpisodeOptionGroups() {
      if (this.assetSections.includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [
              { label: this.$t('main.all_assets'), value: 'all' },
              { label: 'Main Pack', value: 'main' }
            ]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['playlists'].includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [
              { label: this.$t('main.all_assets'), value: 'all' },
              { label: 'Main Pack', value: 'main' }
            ]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['sequences'].includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [{ label: this.$t('sequences.all_sequences'), value: 'all' }]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['edits'].includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [{ label: this.$t('main.all_edits'), value: 'all' }]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['breakdown'].includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [
              { label: this.$t('shots.episodes'), value: 'all' },
              { label: 'Main Pack', value: 'main' }
            ]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['schedule'].includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [
              { label: 'All Episodes', value: 'all' },
            ]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['management'].includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [{ label: 'Project Tasks', value: 'main' }]
          }
        ].concat(this.episodeOptionGroups)
      } else {
        return this.episodeOptionGroups
      }
    },

    isShotPage () {
      return this.$route.params.episode_id
    },

    isProductionContext () {
      return this.$route.params.production_id !== undefined ||
        this.$route.path.indexOf('tasks') > 0
    },

    isEpisodeContext () {
      return this.isTVShow && !([
        'team',
        'news-feed',
        'episodes',
        'production-settings'
      ].includes(this.currentProjectSection))
    },

    lastProduction () {
      return this.productionMap.get(localStorage.getItem('last-production'))
    },

    lastSectionPath () {
      const production = this.lastProduction
      const section = this.lastProductionScreen
      const route = {
        name: section,
        params: {
          production_id: production.id
        }
      }
      if (production.production_type === 'tvshow') {
        route.name = `episode-${section}`
        route.params.episode_id = production.first_episode_id
      }
      return route
    },

    sectionOptions () {
      let options = [
        { label: this.$t('assets.title'), value: 'assets' },
        { label: this.$t('shots.title'), value: 'shots' },
        { label: this.$t('sequences.title'), value: 'sequences' },
        { label: this.$t('episodes.title'), value: 'episodes' },
        { label: this.$t('asset_types.production_title'), value: 'assetTypes' },
        { label: this.$t('playlists.title'), value: 'playlists' }
      ]

      // Show these sections to studio members only.
      if (!this.isCurrentUserClient) {
        options = options.concat([
          { label: this.$t('news.title'), value: 'newsFeed' },
          { label: this.$t('breakdown.title'), value: 'breakdown' },
          { label: this.$t('schedule.title'), value: 'schedule' },
          { label: this.$t('quota.title'), value: 'quota' },
          { label: this.$t('people.team'), value: 'team' }
        ])
      } else {
        const playlistSection = options.pop()
        options = [playlistSection].concat(options)
      }

      if (this.isCurrentUserVendor) {
        options = [
          { label: this.$t('assets.title'), value: 'assets' },
          { label: this.$t('shots.title'), value: 'shots' },
          { label: this.$t('sequences.title'), value: 'sequences' },
          { label: this.$t('episodes.title'), value: 'episodes' },
          { label: this.$t('asset_types.production_title'), value: 'assetTypes' }
        ]
      }

      if (!this.isTVShow) { // Remove episode Section from the list.
        options.splice(3, 1)
      }
      return options
    }
  },

  methods: {
    ...mapActions([
      'loadProjectTasksWithEpisodes',
      'toggleSidebar',
      'clearEpisodes',
      'getShotsFor',
      'loadEpisodes',
      'getSequencesFor',
      'setProduction',
      'setCurrentEpisode',
      'loadTaskTypes',
      'loadSequence',
      'loadSequences',
      'loadShots',
      'loadAssets',
      'loadEdits'
    ]),

    ondebugclick() {
      console.log(this.shotValidationColumns)
    },

    isSchedLit (elem) {
      if (this.$route.query && this.$route.query.filter) {
        return this.$route.query.filter.split('~~').includes(elem.id)
      }
      return false
    },

    isEpLit (epid) {
      return this.currentEpisodeId === epid
    },

    isSeqLit (seq) {
      if (this.$route.query.search === seq.name) { return true }
      else {
        for (const shid in seq.cont) {
          if (this.isShotLit(shid)) {return true}
        }
      }
      return false
    },

    isShotLit (shid) {
      return this.$route.path.includes(`shots/${shid}`)
    },

    isTasksLoading (cat) {
      if (cat === 'shots') {
        return this.isShotsLoading || (this.isTVShow && this.isEpisodesLoading)
      }
      if (cat === 'assets') { return this.isAssetsLoading }
      if (cat === 'edits') { return this.isEditsLoading }
      return false
    },

    taskList (cat) {
      switch (cat) {
        case 'shots':
          return this.shotTasks
        case 'assets':
          return this.assetTasks
        case 'edits':
          return this.editTasks
      }
    },

    taskCount (cat) {
      switch (cat) {
        case 'shots':
          return this.shotTasks.length > 0
        case 'assets':
          return this.assetTasks.length > 0
        case 'edits':
          return this.editTasks.length > 0
      }
    },

    getEpisodePath (episodeId) {
      const route = {
        name: 'episode-shots',
        params: {
          production_id: this.currentProduction.id,
          episode_id: episodeId
        },
        query: {
          search: ''
        }
      }
      return route
    },

    getShotPath (shotId) {
      const route = {
        name: 'shot',
        params: {
          production_id: this.currentProduction.id
        }
      }
      if (this.isTVShow && this.currentEpisode) {
        const shot = this.shotMap.get(shotId)
        route.name = 'episode-shot'
        route.params.episode_id = shot ? shot.episode_id : this.currentEpisode.id
      }
      if (shotId) {
        route.params.shot_id = shotId
      }
      return {params: route.params}
    },

    onSequenceClick (seqid, epid = null) {
      var seq = this.sequenceMap.get(seqid)
      if (!seq) {
        this.loadSequence(seqid).then(seq => {
          if (epid) {
            this.$router.push({
              name: 'episode-shots',
              params: {
                production_id: this.currentProductionId,
                episode_id: epid
              },
              query: {
                search: seq.name
              }
            })
          } else {
            this.pushContextRoute('shots', { search: seq.name } )
          }
        })
      }
      if (epid) {
        this.$router.push({
          name: 'episode-shots',
          params: {
            production_id: this.currentProductionId,
            episode_id: epid
          },
          query: {
            search: seq.name
          }
        })
      } else {
        this.pushContextRoute('shots', { search: seq.name } )
      }
    },

    shotsOfSequence (seq_id) {
      for (const grp of this.displayedShotsBySequence) {
        if (grp[0] && (grp[0].sequence_id === seq_id)) {
          return grp
        }
      }
      return []
    },

    buildFilterUrl (elements) {
      var filter = ''
      for (const elem of elements) {
        if (elem.id) {
          filter += (elem.id + '~~')
        }
      }
      filter = filter.substring(0, filter.length - 2)
      if (this.isTVShow) {
        this.$router.push({
          name: 'episode-schedule',
          params: { episode_id: this.currentEpisodeId },
          query: { filter }
        })
      } else {
        this.$router.push({
          name: 'schedule',
          query: { filter }
        })
      }
    },

    departmentalize (taskTypeIds) {
      const res = {}
      var lastDepId = ''
      taskTypeIds.forEach(id => {
        const taskType = this.taskTypeMap.get(id)
        if (taskType && taskType.department_id && taskType.department_id !== lastDepId) {
          lastDepId = taskType.department_id
          res[lastDepId] = []
        }
        res[taskType.department_id].push(id)
      })
      return res
    },

    formatTaskTypeList (columns) {
      var cols = [...columns]
      return this.departmentalize(
        sortColumnsByDepartment(cols, this.taskTypeMap, this.departmentMap, this.currentProduction)
      )
    },

    taskTypePath (taskTypeId, type) {
      if (type === 'management') {
        return {
          name: 'task-type-management',
          params: {
            production_id: this.currentProduction.id,
            task_type_id: taskTypeId
          }
        }
      } else if (this.isTVShow && this.currentEpisode) {
        return {
          name: 'episode-task-type',
          params: {
            production_id: this.currentProduction.id,
            episode_id: this.currentEpisode.id,
            task_type_id: taskTypeId,
            type: type
          }
        }
      } else {
        return {
          name: 'task-type',
          params: {
            production_id: this.currentProduction.id,
            task_type_id: taskTypeId,
            type: type
          }
        }
      }
    },

    getCurrentSectionFromRoute () {
      let name = ''
      const segments = this.$route.path.split('/')
      if (this.isTVShow) name = segments[5]
      if (!name) {
        name = segments[3]
        if (name === 'episodes' && segments.length === 6) name = segments[5]
      }
      if (name === 'asset-types') name = 'assetTypes'
      if (name === 'news-feed') name = 'newsFeed'
      return name
    },

    updateContext (productionId) {
      if (!productionId) {
        this.clearContext()
      } else {
        this.setProductionFromRoute()
      }
    },

    clearContext () {
      this.silent = true
      this.currentProductionId = null
      this.currentProjectSection = null
      if (!this.isTVShow) {
        this.setCurrentEpisode(null)
        this.currentEpisodeId = null
      }
      this.setProduction(null)
      this.silent = false
    },

    setProductionFromRoute () {
      // console.log("LOADING FROM ROUTE")
      const routeProductionId = this.$route.params.production_id
      const routeEpisodeId = this.$route.params.episode_id

      if (this.isProductionChanged(routeProductionId)) {
        console.log("- production changed")
        this.configureProduction(routeProductionId)
      } else if (this.isEpisodeChanged(routeEpisodeId)) {
        console.log("- episode changed")
        this.configureEpisode(routeEpisodeId)
      }
      this.updateCombosFromRoute()
    },

    configureProduction (routeProductionId) {
      this.setProduction(routeProductionId)
        .then(() => {
          if (this.isTVShow) {
            this.loadEpisodes()
              .then(() => {
                // this.reloadProduction()
                this.setEpisodeFromRoute()
                this.updateCombosFromRoute()
              })
              .then(() => {
                this.reloadTasks()
              })
          } else {
            this.loadSequences()
              .then(() => {
                this.clearEpisodes()
                this.updateCombosFromRoute()
                // this.reloadProduction()
              })
              .then(() => {
                this.reloadTasks()
              })
          }
        })
    },

    configureEpisode (routeEpisodeId) {
      if (this.episodes.length < 2) {
        this.loadEpisodes()
          .then(() => {
            this.setEpisodeFromRoute()
            this.updateCombosFromRoute()
          })
      } else {
        this.setEpisodeFromRoute()
        this.updateCombosFromRoute()
      }
      this.reloadTasks()
    },

    isProductionChanged (productionId) {
      return productionId && (
        !this.currentProduction ||
        this.currentProductionId !== productionId ||
        this.currentProduction.id !== productionId
      )
    },

    isEpisodeChanged (episodeId) {
      return (
        this.isTVShow && episodeId &&
        (
          !this.currentEpisode ||
          this.currentEpisodeId !== episodeId ||
          this.currentEpisode.id !== episodeId
        )
      )
    },

    setEpisodeFromRoute () {
      const routeEpisodeId = this.$route.params.episode_id
      if (this.isEpisodeChanged(routeEpisodeId)) {
        if (routeEpisodeId && this.isTVShow) {
          this.setCurrentEpisode(routeEpisodeId)
        }
      } else if (!routeEpisodeId) {
        this.silent = true
        this.clearEpisodes()
        this.currentEpisodeId = null
        this.silent = false
      }
    },

    updateCombosFromRoute () {
      const productionId = this.$route.params.production_id
      const episodeId = this.$route.params.episode_id
      const section = this.getCurrentSectionFromRoute()
      this.silent = true
      this.currentProductionId = productionId
      this.currentProjectSection = section
      this.currentProjectSection = null
      this.$nextTick(() => {
        this.currentProjectSection = section
        this.currentEpisodeId = null
        this.$nextTick(() => {
          this.currentEpisodeId = episodeId
          this.silent = false
        })
      })
    },

    updateRoute () {
      if (this.silent) return

      const productionId = this.$route.params.production_id
      const episodeId = this.$route.params.episode_id
      const sectionFromRoute = this.getCurrentSectionFromRoute()
      let section = this.currentProjectSection

      const isProperContext =
        section &&
        this.$route.path.indexOf('manage') < 0

      const isContextChanged =
        section !== sectionFromRoute ||
        productionId !== this.currentProductionId ||
        (
          this.currentEpisodeId &&
          episodeId &&
          episodeId !== this.currentEpisodeId
        )

      if (isProperContext && isContextChanged) {
        if (section === 'newsFeed') section = 'news-feed'
        if (section === 'assetTypes') section = 'production-asset-types'
        this.pushContextRoute(section)
      }
    },

    getContextRoute (section, query = null) {
      var episodeId = this.currentEpisodeId
      if (section === 'schedule' && ['main'].includes(this.currentEpisodeId)) {
        episodeId = 'all'
      } else if (
        (!['asset', 'playlists'].includes(section) && ['all', 'main'].includes(this.currentEpisodeId))
      ) {
        episodeId = this.episodes.length > 0 ? this.episodes[0].id : null
      }
      const isTVShow = !!this.currentEpisodeId
      let route = {
        name: section,
        params: {
          production_id: this.currentProductionId
        }
      }
      if (query) route.query = query
      route = this.episodifyRoute(route, section, episodeId, isTVShow)
      return route
    },

    pushContextRoute (section, query = null) {
      const route = this.getContextRoute(section, query)
      if (route && route.params.production_id) {
        this.$router.push(route)
      }
    },

    episodifyRoute (route, section, episodeId, isTVShow) {
      const isEpisodeContext =
        isTVShow &&
        section !== 'team' &&
        section !== 'news-feed' &&
        section !== 'episodes' &&
        section !== 'production-settings'
      if (isEpisodeContext) {
        route.name = `episode-${section}`
        route.params.episode_id = episodeId
      }
      return route
    },

    reset () {
      this.title = this.organisation.name
      this.logoPath = '/api/pictures/thumbnails/organisations/' +
        `${this.organisation.id}.png?t=` + new Date().toISOString()
    },

    reloadTasks () {
      if (
        this.isTVShow ||
        (this.currentProduction &&
        this.episodes.length > 0 &&
        this.episodes[0].project_id !== this.currentProduction.id)
      ) {
        this.loadTaskTypes()
          .then(() => this.loadEpisodes())
          .then(() => this.loadShots(() => {}))
          .then(() => {
            // this.shotTasks = this.formatTaskTypeList(this.shotValidationColumns)
          })
          .catch(console.error)
      } else {
        this.loadTaskTypes()
          .then(() => this.loadShots(() => {}))
      }
      this.loadAssets()
      this.loadEdits()
      this.managementTasks = this.formatTaskTypeList(
        this.productionManagementTaskTypes.map(
          (taskType) => { return taskType.id }
        )
      )
    },

    reloadProduction() {
      console.log("FULL RELOAD")
      this.loadingEpseq = true
      this.epSeqTree = {}
      const tree = this.epSeqTree
      if (this.isTVShow) {
        // func.runPromiseAsSeries([
        //   this.episodes.map((ep) => {
        //     return this.getShotsFor({
        //       production: this.currentProduction,
        //       episode: ep
        //     })
        //   })
        // ]).then((shotGroups) => {
        //   shotGroups.forEach((shots, epIndex) => {
        //     const ep = this.episodes[epIndex]
        //     shots.forEach (sh => {
        //       if (sh.sequence_id in tree[ep.id].cont) {
        //         tree[ep.id].cont[sh.sequence_id].cont[sh.id] = sh.name
        //       } else {
        //         tree[ep.id].cont[sh.sequence_id] = {
        //           name: sh.sequence_name,
        //           cont: { [sh.id]: sh.name }
        //         }
        //       }
        //     })
        //   })
        // }).then(() => { this.loadingEpseq = false })
        for (const ep of this.episodes) {
          tree[ep.id] = {
            name: ep.name,
            cont: {}
          }
          if (ep.data.title) {
            tree[ep.id].name += ` - ${ep.data.title}`
          }
          this.getShotsFor({
            production: this.currentProduction,
            episode: ep
          })
            .then(shots => {
              shots.forEach (sh => {
                if (!sh.canceled) {
                  if (sh.sequence_id in tree[ep.id].cont) {
                    tree[ep.id].cont[sh.sequence_id].cont[sh.id] = sh.name
                  } else {
                    tree[ep.id].cont[sh.sequence_id] = {
                      name: sh.sequence_name,
                      cont: { [sh.id]: sh.name }
                    }
                  }
                }
              })
              // this.getSequencesFor({episode: this.episodeMap.get(ep.id)})
              //   .then(seqs => {
              //     seqs.forEach(seq => {
              //       tree[ep.id].cont[seq.id] = {
              //         name: seq.name,
              //         cont: {}
              //       }
              //       shots.forEach (sh => {
              //         if (sh.sequence_id === seq.id) {
              //           tree[ep.id].cont[seq.id].cont[sh.id] = sh.name
              //         }
              //       })
              //     })
              //   })
            })
            .then(() => {
              // TODO: find a better sollution to update epseqtree component!!!
              this.loadingEpseq = !this.loadingEpseq
              this.loadingEpseq = !this.loadingEpseq
            })
        }
        this.loadingEpseq = false
      } else {
        this.getShotsFor({ production: this.currentProduction, episode: null })
          .then(shots => {
            shots.forEach (sh => {
              if (!sh.canceled) {
                if (sh.sequence_id in tree) {
                  tree[sh.sequence_id].cont[sh.id] = sh.name
                } else {
                  tree[sh.sequence_id] = {
                    name: sh.sequence_name,
                    cont: { [sh.id]: sh.name }
                  }
                }
              }
            })
            // this.getSequencesFor({})
            //   .then(seqs => {
            //     seqs.forEach(seq => {
            //       tree[seq.id] = {
            //         name: seq.name,
            //         cont: {}
            //       }
            //       shots.forEach (sh => {
            //         if (sh.sequence_id === seq.id) {
            //           tree[seq.id].cont[sh.id] = sh.name
            //         }
            //       })
            //     })
            //   })
          })
          .then(() => { this.loadingEpseq = false })
      }
    }
  },

  watch: {
    $route () {
      const productionId = this.$route.params.production_id
      this.updateContext(productionId)
      if (productionId) {
        localStorage.setItem('last-production', productionId)
      }
      this.reset()
    },

    currentProductionId () {
      if (this.currentProduction.isTVShow) this.loadEpisodes()
      this.updateRoute()
      this.resetSchedule()
    },

    currentProjectSection () {
      if (this.silent) return
      this.updateRoute()
    },

    currentEpisodeId () {
      if (this.silent) return
      this.updateRoute()
    },

    currentEpisode () {
      if (!this.currentEpisode) {
        this.currentEpisodeId = null
      } else if (this.currentEpisodeId !== this.currentEpisode.id) {
        this.currentEpisodeId = this.currentEpisode.id
      }
      this.resetSchedule()
    },

    scheduleSortMode () {
      this.resetSchedule()
    }

    // organisation () {
    //   this.reloadTasks()
    //   this.reset()
    // }
  }
}
</script>

<style lang="scss" scoped>
// dark
.aside {
  background-color: #2f3136;
  color: $grey;
}

.chevron {
  margin-right: 2px;
  margin-left: -3px;
  scale: 70%;
  height: 1.5rem;
  width: 1.5rem;
  font-size: 21px;
  cursor: pointer;
}

aside {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 300px;
  // background-color: white;

  background-color: #2f3136;
  color: $grey;
  padding: 20px 1em 1em 1em;
  overflow-y: auto;
  z-index: 205;
  box-shadow: 1px 0px 6px rgba(0,0,0,0.2);
  transition-property: all;
  transition-duration: .5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

aside.hidden {
  left: -200px;
}

aside p a {
  font-size: 1.1em;
  /* text-transform: uppercase; */
  color: $grey;
}

aside section {
  height: 100%;
  overflow-y: scroll;
  overflow-x: clip;
  margin-top: 2em;
}

.sidebar-title {
  margin-top: 0.5em;
  margin-bottom: 1.5em;
  text-align: center;
  font-size: 1.6em;
}

.company-logo {
  margin-left: 1em;
  margin-top: -20px;
  height: 80px;
  width: 80px;
  margin-bottom: 0.5em;
}

.logo-text {
  color: $light-grey;
  font-weight: bold;
  position: absolute;
  top: 44px;
  left: 90px;
  font-size: 11pt;
}

.context-selector {
  margin-right: 0.5em;
}

::v-deep img {
  filter: brightness(90);
}

::v-deep .select-input {
  background: $dark-grey-strong;
  color: $white;
}

::v-deep .selected-episode-line {
  background: $dark-grey-strong;
  color: $white;
}

::v-deep .episode-line {
  background: $dark-grey-strong;
  color: $white;
}

#c-mask {
  position: fixed;
  z-index: 204;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 0;
  height: 0;
  background-color: #000;
  opacity: 0;
}

#c-mask.is-active {
  width: 100%;
  height: 100%;
}

h2 {
  margin-top: 0;
  color: $light-grey;
  text-transform: uppercase;
}

h3 {
  color: $light-grey;
  margin-top: 1em;
  font-size: 12pt;
}

@media screen and (max-width: 768px) {
  .company-logo img {
    width: 40px;
    margin: 0;
    flex: 1;
  }

  .home-link {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

p {
  font-size: 1em;
}

.bright {
  color: $white-grey;
}

.bold {
  font-weight: bold;
}

.tasks-department-name {
  cursor: pointer;
}

.notreeicon {
  width: 18px;
  margin-left: 20px;
  margin-right: 6px;
}

.production-select {
  margin-bottom: 0;
}

.navcontent {
  overflow: clip;
  height: 100%;
}

.lit {
  font-weight: bold;
  color: $white;
}

.seq-task-area-side {
  margin: 0 0 8pt 0;
}

.peoplespacer {
  height: 10px;
}
</style>
